import * as THREE from 'three';

export function createLighting(scene) {
   const keyLight = new THREE.DirectionalLight(0xffffff, 3.5);
   keyLight.position.set(-2, 1, 2);
   keyLight.castShadow = true;
   keyLight.shadow.mapSize.set(2048, 2048);
   keyLight.shadow.bias = 0.0005;
   keyLight.shadow.normalBias = 0.05;
   keyLight.shadow.camera.near = 0.5;
   keyLight.shadow.camera.far = 50;
   keyLight.shadow.camera.left = -20;
   keyLight.shadow.camera.right = 20;
   keyLight.shadow.camera.top = 20;
   keyLight.shadow.camera.bottom = -20;
   scene.add(keyLight);

   const fillLight = new THREE.DirectionalLight(0xffffff, 1.5);
   fillLight.position.set(1, 1.5, -1);
   scene.add(fillLight);

   const ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
   scene.add(ambientLight);

   return { keyLight, fillLight, ambientLight };
}
